import { gql } from '@apollo/client';

import { subscriptionPartial } from '../partials';
import { cartPartial } from '../partials/cart/Cart';

export const addToCart = gql`
  mutation addToCart($productID: Int!, $quantity: Int!, $extraData: String) {
    addToCart(input: { productId: $productID, quantity: $quantity, extraData: $extraData }) {
      clientMutationId
      ${cartPartial(subscriptionPartial)}
    }
  }
`;
